import * as EventConstants from 'constants/EventConstants';
import {BioentitySummary} from 'folder-items/FileConstants';
import AppDispatcher from 'lib/Dispatcher';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import * as ManagedModelsReduxActions from 'models/ManagedModelsReduxActions';
import * as ModelActions from 'redux-stores/ModelActions';
import {getStore} from 'redux-stores/Store';
import * as SampleActions from 'samples/SampleActions';
import {populateSearchParamWithDefaultSort} from 'search/getSortsOrDefault';
import {SearchParams, SearchResults, SearchType} from 'search/SearchConstants';

import * as BioentityDAO from './BioentityDAO';
import {BioentityAndBatchSearchResponse} from './BioentityDAO';

async function listBioentitiesAndBatchesCompleteResponse(
  searchParams: SearchParams
): Promise<BioentityAndBatchSearchResponse> {
  const searchParamsWithDefault = populateSearchParamWithDefaultSort(
    searchParams,
    SearchType.BIOENTITIES_AND_BATCHES
  );
  const {
    ids,
    total,
    isExact,
    timedOut,
    batches,
    fileSummariesById,
    permissionsByModelId,
    bioentityAliasInfosByBioentityId,
    correlationId,
    scoresById,
    groups,
    nextToken,
  } = await BioentityDAO.listBioentitiesAndBatches(searchParamsWithDefault);
  SampleActions.handleBatchesLoaded(batches);
  getStore().dispatch(
    ManagedModelsReduxActions.modelFetched(ManagedModelType.PERMISSIONS_BY_ITEM_ID, permissionsByModelId)
  );
  getStore().dispatch(ModelActions.filesFetchCompleted(fileSummariesById));
  AppDispatcher.dispatch({
    actionType: EventConstants.BIOENTITY_ALIAS_INFO_LOAD_COMPLETED,
    bioentityAliasInfosById: bioentityAliasInfosByBioentityId,
  });
  return {
    ids,
    groupItemIds: [],
    total,
    isExact,
    timedOut,
    batches,
    fileSummariesById,
    permissionsByModelId,
    bioentityAliasInfosByBioentityId,
    correlationId,
    scoresById,
    groups,
    nextToken,
  };
}

export interface BioentitySummarySearchResponse extends SearchResults {
  fileSummariesById: {[id: string]: BioentitySummary};
}

export async function listBioentitiesAndBatchesWithSummaries(
  searchParams: SearchParams
): Promise<BioentitySummarySearchResponse> {
  const {ids, total, isExact, timedOut, fileSummariesById, scoresById, groups, nextToken} =
    await listBioentitiesAndBatchesCompleteResponse(searchParams);
  return {ids, groupItemIds: [], total, isExact, timedOut, fileSummariesById, scoresById, groups, nextToken};
}
